import classNames from 'classnames'
import { observer } from 'mobx-react-lite'

import { dmsState } from '@/app/store'

import PaginationLeft from './icons/pagination-left.svg'
import PaginationRight from './icons/pagination-right.svg'
import style from './Pagination.module.scss'
import { onGetCurrentPage } from './utils/onGetCurrentPage'
import { onGetFinalPages } from './utils/onGetFinalPages'
import { onGetInitialPages } from './utils/onGetInitialPages'
import { onGetMiddlePages } from './utils/onGetMiddlePages'

interface IProps {
    maxPages?: number
    onGetPage: (value: number) => void
    onGetPrevPage: () => void
    onGetNextPage: () => void
}

export const Pagination = observer((props: IProps) => {
    const { maxPages = 5, onGetPage, onGetNextPage, onGetPrevPage } = props

    const skip = dmsState.insuredFilters.skip
    const totalCount = dmsState.insuredFilters.totalCount
    const top = dmsState.insuredFilters.top

    const pages = Array(Math.ceil(totalCount / top))
        .fill(null)
        .map((_, idx) => idx)

    if (pages.length < 1) {
        return null
    }

    const chosenPage = onGetCurrentPage(skip, top)
    const initialPages = onGetInitialPages(chosenPage, maxPages, pages)
    const middlePages = onGetMiddlePages(chosenPage, maxPages, pages)
    const finalPages = onGetFinalPages(chosenPage, maxPages, pages)

    return (
        <div className={style.container}>
            <div className={style.pagesWrapper}>
                <div
                    className={classNames(style.page, style.paginationLeft, skip === 0 && style.disabledPage)}
                    onClick={onGetPrevPage}
                >
                    <PaginationLeft />
                </div>
            </div>
            <div className={style.pagesWrapper}>
                {pages.length <= maxPages + 1 &&
                    pages.map((value) => {
                        const currentPage = value + 1
                        return (
                            <div
                                key={value}
                                className={classNames(style.page, value === skip / top && style.currentPage)}
                                onClick={() => onGetPage(value * top)}
                            >
                                <span>{currentPage}</span>
                            </div>
                        )
                    })}
                {pages.length > maxPages + 1 &&
                    initialPages.map((value) => {
                        const currentPage = value + 1
                        return (
                            <div
                                key={value}
                                className={classNames(style.page, value === skip / top && style.currentPage)}
                                onClick={() => onGetPage(value * top)}
                            >
                                <span>{currentPage}</span>
                            </div>
                        )
                    })}
                {pages.length > maxPages + 1 && (
                    <div>
                        <span>...</span>
                    </div>
                )}
                {pages.length > maxPages + 1 &&
                    middlePages?.map((value, idx) => {
                        const currentPage = value + 1
                        return (
                            <div
                                key={idx}
                                className={classNames(style.page, value === skip / top && style.currentPage)}
                                onClick={() => onGetPage(value * top)}
                            >
                                <span>{currentPage}</span>
                            </div>
                        )
                    })}
                {middlePages && pages.length > maxPages + 1 && (
                    <div>
                        <span>...</span>
                    </div>
                )}
                {pages.length > maxPages + 1 &&
                    finalPages?.map((value, idx) => {
                        const currentPage = value + 1
                        return (
                            <div
                                key={idx}
                                className={classNames(style.page, value === skip / top && style.currentPage)}
                                onClick={() => onGetPage(value * top)}
                            >
                                <span>{currentPage}</span>
                            </div>
                        )
                    })}
            </div>
            <div className={style.pagesWrapper}>
                <div
                    className={classNames(
                        style.page,
                        style.paginationRight,
                        chosenPage === pages.length && style.disabledPage
                    )}
                    onClick={onGetNextPage}
                >
                    <PaginationRight />
                </div>
            </div>
        </div>
    )
})
